import { ChevronDown } from 'lucide-react';
import React from 'react';

export default function TimelineBar() {
  const startYear = 1450;
  const endYear = 1650;
  const activeYear = 1548;
  const interval = 25;

  const years = [];
  for (let y = startYear; y <= endYear; y += interval) {
    years.push(y);
  }

  return (
    <div className="timeline-bar-container">
      <div className="vertical-connector"></div>

      <div className="timeline-ruler">
        <div className="years-wrapper">
          {years.map((year) => (
            <div key={year} className={`year-marker ${year === 1450 || year === 1575 ? 'border-year' : ''}`}>
              <span className="year-text">{year}</span>
            </div>
          ))}
        </div>

        <div className="active-year-badge">
          <span className="active-year-text">{activeYear}</span>
        </div>
        <ChevronDown />

        <div className="fade-overlay fade-left"></div>
        <div className="fade-overlay fade-right"></div>
      </div>
    </div>
  );
}
